
export const styles = {
    defaultDialogStyles: {
        width: '98%',
        height: '75%%',
        maxHeight: '85%',
        position: 'fixed',
        top: '70px',
        left: '1%',
        marginTop: '0%',
        marginLeft: '0%',
        backgroundColor: '#fff',
        borderRadius: '2px',
        zIndex: 100,
        padding: '15px',
        boxShadow: '0 0 4px rgba(0,0,0,.14),0 4px 8px rgba(0,0,0,.28)',
        overflow: 'auto'
    },
    sidebarMenuItem: {
        sidebar: {
            width: 256,
            height: '100%',
        },
        sidebarLink: {
            display: 'block',
            padding: '16px 0px',
            color: '#000000',
            textDecoration: 'none',
        },
        divider: {
            margin: '8px 0',
            height: 1,
            backgroundColor: '#757575',
        },
        content: {
            padding: '16px',
            height: '100%',
            backgroundColor: 'white',
        }
    }
};